var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFamily(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_180_469)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.94999 19.2C1.94999 15.1409 4.93275 11.85 8.79999 11.85C11.4125 11.85 13.5452 13.3351 14.7571 15.5386C14.9568 15.9015 14.8244 16.3575 14.4614 16.5572C14.0985 16.7568 13.6424 16.6244 13.4428 16.2614C12.4547 14.4649 10.7875 13.35 8.79999 13.35C5.86722 13.35 3.44999 15.8591 3.44999 19.2C3.44999 19.5169 3.45591 19.6961 3.5115 19.8628C3.64248 20.2558 3.43011 20.6805 3.03716 20.8115C2.6442 20.9425 2.21946 20.7301 2.08847 20.3372C1.94944 19.9201 1.94975 19.5145 1.94997 19.2322C1.94998 19.2213 1.94999 19.2105 1.94999 19.2Z",
    fill: "#1E9AA6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.00001 11.5C6.70001 11.5 4.80001 9.6 4.80001 7.3C4.70001 4.9 6.60001 3 9.00001 3C11.3 3 13.2 4.9 13.2 7.2C13.2 9.6 11.3 11.5 9.00001 11.5ZM9.00001 4.2C7.30001 4.2 5.90001 5.6 5.90001 7.3C5.90001 9 7.30001 10.4 9.00001 10.4C10.7 10.4 12.1 9 12.1 7.3C12 5.6 10.7 4.2 9.00001 4.2Z",
    fill: "#1E9AA6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2 20.9C10.2 17.8 12.6 15.2 15.6 15.2C16 15.2 16.3 15.5 16.3 15.9C16.3 16.3 16 16.6 15.6 16.6C13.3 16.6 11.5 18.5 11.5 20.9C11.5 21.3 11.2 21.6 10.8 21.6C10.5 21.6 10.2 21.3 10.2 20.9Z",
    fill: "#F3725D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.2 20.9C20.2 19.7 19.7 18.5 18.8 17.7C18.5 17.5 18.5 17 18.8 16.8C19.1 16.5 19.6 16.6 19.8 16.8C21 17.9 21.6 19.4 21.6 21C21.6 21.4 21.3 21.7 20.8 21.7C20.5 21.6 20.1 21.2 20.2 20.9Z",
    fill: "#F3725D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.3 16.4C14.2 16.4 12.5 14.7 12.5 12.6C12.5 10.5 14.2 8.8 16.3 8.8C18.4 8.8 20.1 10.5 20.1 12.6C20.1 14.7 18.4 16.4 16.3 16.4ZM16.3 9.8C14.8 9.8 13.6 11 13.6 12.5C13.6 14 14.8 15.2 16.3 15.2C17.8 15.2 19 14 19 12.5C19 11.1 17.8 9.8 16.3 9.8Z",
    fill: "#1E9AA6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_180_469"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.6,
    height: 18.6,
    fill: "white",
    transform: "translate(2 3)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFamily);
export default __webpack_public_path__ + "static/media/family.b9041a3383a2f5bbeae85d5f2da00863.svg";
export { ForwardRef as ReactComponent };